import { useTranslation } from "react-i18next";
import { InfoActionCard } from "@app/dashboard/components/inner_layout/InfoActionCard";
import { useSettingsUtils } from "./useSettingsUtils";
import styles from "./settings.module.scss";

export const Settings = () => {
  const { t } = useTranslation();

  const { settingsCards, developersCards } = useSettingsUtils();

  return (
    <div className={styles["settings-wrapper"]}>

      <div className={styles["settings-wrapper__main-section"]}>
        {
          !!settingsCards.length &&
          <>
            <div className={styles["settings-wrapper__main-section__title-box"]}>
              <div className={styles["settings-wrapper__main-section__title-box__title"]}>
                {t('innerLayout.settingsPage.title')}
              </div>

              <div className={styles["settings-wrapper__main-section__title-box__desc"]}>
                {t('innerLayout.settingsPage.desc')}
              </div>
            </div>

            <div className={styles["settings-wrapper__main-section__boxes"]}>
              {
                settingsCards.map((card, index) =>
                  <InfoActionCard
                    key={`settings-action-card-${index}`}
                    size="lg"
                    color="primary"
                    icon={card.icon}
                    title={card.title}
                    desc={card.desc}
                    onClickHandler={card.onClickHandler}
                  />
                )
              }
            </div>
          </>
        }
      </div>


      <div className={styles["settings-wrapper__secondary-section"]}>
        {
          !!developersCards.length &&
          <>
            <div className={styles["settings-wrapper__secondary-section__title-box"]}>
              <div className={styles["settings-wrapper__secondary-section__title-box__title"]}>
                {t('innerLayout.settingsPage.secondaryTitle')}
              </div>
            </div>

            <div className={styles["settings-wrapper__secondary-section__boxes"]}>
              {
                developersCards.map((card, index) =>
                  <InfoActionCard
                    key={`developers-action-card-${index}`}
                    size="lg"
                    color="primary"
                    icon={card.icon}
                    title={card.title}
                    desc={card.desc}
                    onClickHandler={card.onClickHandler}
                  />
                )
              }
            </div>
          </>
        }
      </div>

    </div>
  )
}
